// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3T3r1","content":"GlobalSearch_content__2E7aj"};